<script lang="ts" setup>
import {storeToRefs} from 'pinia'

import ChartPieIcon from '@/assets/icons/chart-pie.svg'
import InfoIcon from '@/assets/icons/info.svg'
import DashboardIcon from '@/assets/icons/dashboard.svg'
import LogoutIcon from '@/assets/icons/logout.svg'
import UsersIcon from '@/assets/icons/user-group.svg'
import DividerComponent from '@/components/ui/DividerComponent.vue'
import {useUiStore} from '@/stores/ui-store'
import {useUserStore} from '@/stores/user-store'

defineProps<{
  isSidebarExpanded: boolean
}>()

const emit = defineEmits(['link-clicked'])
const userStore = useUserStore()
const uiStore = useUiStore()

const { showAdminMenu } = storeToRefs(uiStore)
const { user } = storeToRefs(userStore)

const handleMobileLinkClick = () => {
  if (window.innerWidth <= 991) {
    emit('link-clicked')
  }
}

const { signOut } = userStore
</script>

<template>
  <aside class="layout-menu flex flex-col gap-4 h-full">
    <div class="flex flex-col gap-4">
      <RouterLink class="admin-link" to="/admin" @click="handleMobileLinkClick">
        <DashboardIcon />
        <span v-if="isSidebarExpanded">{{ $t('common:dashboard') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/admin/analisi" @click="handleMobileLinkClick">
        <ChartPieIcon />
        <span v-if="isSidebarExpanded">{{ $t('common:analysis') }}</span>
      </RouterLink>

      <RouterLink class="admin-link" to="/blog" @click="handleMobileLinkClick">
        <InfoIcon />
        <span v-if="isSidebarExpanded">{{ $t('common:blog') }}</span>
        <Badge severity="secondary">{{ $t('common:soon') }}</Badge>
      </RouterLink>

      <template v-if="user?.admin && showAdminMenu">
        <DividerComponent />

        <RouterLink class="admin-link" to="/admin/utenti" @click="handleMobileLinkClick">
          <UsersIcon />
          <span v-if="isSidebarExpanded">{{ $t('common:users') }}</span>
        </RouterLink>
      </template>
    </div>
    <div class="mt-auto">
      <button class="admin-link" @click="() => signOut(true)">
        <LogoutIcon />
        <span v-if="isSidebarExpanded">{{ $t('common:logout') }}</span>
      </button>
    </div>
  </aside>
</template>

<style lang="scss" scoped>
.admin-link {
  @apply flex gap-4 hover:bg-neutral-100 px-4 py-3 w-full rounded-xl;

  &.router-link-exact-active {
    @apply bg-brand-primary text-white;
  }
}
</style>
